import { COUNT_POLL_MS, syncDivergenceCount } from '@krp/sync-ui'

/**
 * Сколько расхождений ждут решения человека (требования 11, 20.20): число у пункта меню «Синхронизация». Обновляется само, без F5,
 * раз в минуту, пока вкладка браузера на виду. Нет права смотреть синхронизацию — запрос не удался, число 0 и значка нет.
 */
export function useSyncDivergenceCount(): number {
  const count = syncDivergenceCount.useQuery(undefined, { pollingInterval: COUNT_POLL_MS, skipPollingIfUnfocused: true })
  return count.data?.total ?? 0
}
